import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useAppSelector } from '../../../../../store';
import { Stack } from '@mui/material';
import CusLabelSelect from '../../../../../components/material-ui/CusLabelSelect';
import CusButton from '../../../../../components/material-ui/CusButton';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';

export default function CasinoCurrencies() {
  const { casinoId } = useParams();
  const { successToast } = useToast();
  const [selectCurrencies, setSelectCurrencies] = useState([]);
  const currenciesInfo = useAppSelector((state) => state.user.info.currency);
  const currencyOptions = Object.keys(currenciesInfo).map((el) => ({ label: el, value: el }));

  useEffect(() => {
    API_CASINO.get
      .props({ casinoId: +casinoId, propsCasino: ['currencyList'] })
      .then((e) => {
        const info = e.data.info;

        setSelectCurrencies(info.currencyList);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    API_CASINO.update({ casinoId: +casinoId, currencyList: selectCurrencies })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <CasinoContainer title={'Game balance currencies'}>
      <Stack display={'flex'} direction={'column'} gap={1}>
        <CusLabelSelect
          label={'Currencies'}
          options={currencyOptions}
          multi
          value={selectCurrencies}
          onChange={(val) => {
            setSelectCurrencies(val);
          }}
        />

        <CasinoBtnSave onClick={onSaveClick} />
      </Stack>
    </CasinoContainer>
  );
}
